import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext'; 
import './NavBar.css';

export default function Navbar() {
  const navigate = useNavigate();
  const { user, logout } = useAuth(); // Destructure logout from context
  const [isOpen, setIsOpen] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);

const handleLogout = async () => {
  try {
    if (typeof logout === 'function') {
      await logout(); // Now this will work
      setShowDropdown(false);
      navigate('/login');
    } else {
      console.error("Logout function not found in AuthContext");
    }
  } catch (error) {
    console.error("Logout failed", error);
  }
};

  const handleNav = (path) => {
    setIsOpen(false);
    setShowDropdown(false);
    navigate(path);
  };


  return (
    <nav className="main-nav">
      <div 
        className="nav-logo" 
        onClick={() => handleNav('/landing')} 
        role="button" 
      >
        <div className="rewind-logo-container">
          <span className="logo-rewind">O N E  S T O P</span>
          <span className="logo-dot">.</span>
          <span className="logo-25">2 5</span>
        </div>
      </div>

      <div className={`hamburger ${isOpen ? 'active' : ''}`} onClick={() => setIsOpen(!isOpen)}>
        <span className="bar"></span>
        <span className="bar"></span>
        <span className="bar"></span>
      </div>
      
      <div className={`nav-links ${isOpen ? 'open' : ''}`}>
        {/* Only show these if logged in */}
        {user && (
          <>
            <Link to={`/inout/${user.uid}`} onClick={() => setIsOpen(false)}>In/Out</Link>
            <Link to={`/manifestations/${user.uid}`} onClick={() => setIsOpen(false)}>2026 Manifesto</Link>
            <Link to={`/mylist/${user.uid}`} onClick={() => setIsOpen(false)}>My Bucketlist</Link>
            <Link to={`/groupslist/${user.uid}`} onClick={() => setIsOpen(false)}>Grouplist</Link>
            
            {/* MY PAGE Dropdown */}
            <div className="nav-item-dropdown">
              <button 
                className="my-page-btn" 
                onClick={() => setShowDropdown(!showDropdown)}
              >
                MY PAGE ▼
              </button>
              {showDropdown && (
                <div className="dropdown-menu">
                  <button onClick={() => handleNav(`/dashboard/${user.uid}`)}>DASHBOARD</button>
                  <button className="logout-link" onClick={handleLogout}>LOGOUT</button>
                </div>
              )}
            </div>
          </>
        )}

        {!user && <Link to="/login" onClick={() => setIsOpen(false)}>LOGIN</Link>}
        
        <Link to={`/aura/${user.uid}`}className="vote-btn" onClick={() => setIsOpen(false)}>My Aura</Link>
      </div>
    </nav>
  );
}